import { useMutation } from "@apollo/client";
import { RESTORE_PRUNED_CLIP } from "MVVM/GraphQL/restorePrunedClip";

export const PrunedViewModel = ({
  clipId,
  refetchClip,
}: {
  clipId: string;
  refetchClip: () => void;
}) => {
  const [createPrunedClip] = useMutation(RESTORE_PRUNED_CLIP, {});

  const recoverPrunedClip = async () => {
    await createPrunedClip({
      variables: {
        clipIdentifier: clipId,
      },
    });
    refetchClip();
  };

  return {
    recoverPrunedClip,
  };
};
